window.emotions = {};
window.emotions.code=["/::)","/::~","/::B","/::|","/:8-)","/::<","/::$","/::X","/::Z","/::’(","/::-|","/::@","/::P","/::D","/::O","/::(","/::+","/:–b","/::Q","/::T","/:,@P","/:,@-D","/::d","/:,@o","/::g","/:|-)","/::!","/::L","/::>","/::,@","/:,@f","/::-S","/:?","/:,@x","/:,@@","/::8","/:,@!","/:!!!","/:xx","/:bye","/:wipe","/:dig","/:handclap","/:&-(","/:B-)","/:<@","/:@>","/::-O","/:>-|","/:P-(","/::’|","/:X-)","/::*","/:@x","/:8*","/:pd","/:<W>","/:beer","/:basketb","/:oo","/:coffee","/:eat","/:pig","/:rose","/:fade","/:showlove","/:heart","/:break","/:cake","/:li","/:bome","/:kn","/:footb","/:ladybug","/:shit","/:moon","/:sun","/:gift","/:hug","/:strong","/:weak","/:share","/:v","/:@)","/:jj","/:@@","/:bad","/:lvu","/:no","/:ok","/:love","/:<L>","/:jump","/:shake","/:<O>","/:circle","/:kotow","/:turn","/:skip","[挥手]","/:#-0","[街舞]","/:kiss","/:<&","/:&>"];
window.emotions.keyword=["微笑","伤心","美女","发呆","墨镜","哭","羞","哑","睡","哭","囧","怒","调皮","笑","惊讶","难过","酷","汗","抓狂","吐","笑","快乐","奇","傲","饿","累","吓","汗","高兴","闲","努力","骂","疑问","秘密","乱","疯","哀","鬼","打击","bye","汗","抠","鼓掌","糟糕","恶搞","什么","什么","累","看","难过","难过","坏","亲","吓","可怜","刀","水果","酒","篮球","乒乓","咖啡","美食","动物","鲜花","枯","唇","爱","分手","生日","电","炸弹","刀","足球","虫","臭","月亮","太阳","礼物","伙伴","赞","差","握手","优","恭","勾","顶","坏","爱","不","好的","爱","吻","跳","怕","尖叫","圈","拜","回头","跳","天使","激动","舞","吻","瑜伽","太极"];
export default {
    getQueryString(name) {
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
   },
    formatMoney(s, n) {
        if (typeof s == "undefined") {
            return "";
        }
        else if (typeof n == "undefined") {
          n = 2;
        }
         n = n > 0 && n <= 20 ? n : 2;   
         s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";   
         var negative = false;
         if (s.substr(0, 1) == '-') {
            negative = true;
            s = s.substr(1);
         }
         var l = s.split(".")[0].split("").reverse(),   
         r = s.split(".")[1];   
         var t = "";   
         for(var i = 0; i < l.length; i ++ )
         {   
            t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");   
         }   
         return (negative?"-":"") + t.split("").reverse().join("") + "." + r;   
    },
    formatDate(date, fmt) {
        if (!date) {
        return "";
        }
        if (typeof(date) == "string") {
            if (date.indexOf(".") > -1) {
                // 有些日期接口返回带有.0。
                date = date.substring(0, date.indexOf("."));
            }
            // 解决IOS上无法从dateStr parse 到Date类型问题
            date = date.replace(/-/g, '/');
            date = new Date(date);
        }
        var o = { 
            "M+" : date.getMonth()+1,                 //月份 
            "d+" : date.getDate(),                    //日 
            "h+" : date.getHours(),                   //小时 
            "m+" : date.getMinutes(),                 //分 
            "s+" : date.getSeconds(),                 //秒 
            "q+" : Math.floor((date.getMonth()+3)/3), //季度 
            "S"  : date.getMilliseconds()             //毫秒 
        }; 
        if(/(y+)/.test(fmt)) {
                fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
        }
         for(var k in o) {
            if(new RegExp("("+ k +")").test(fmt)){
                 fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
             }
         }
        return fmt; 
    },
    format() {
        if(arguments[1] == null) return "";
        var regex = /%%|%(\d+\$)?([-+\'#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuideEfFgG])/g;
        var a = arguments;
        var i = 0;
        var format = a[i++];

        // pad()
        var pad = function(str, len, chr, leftJustify) {
            if (!chr) {
                chr = ' ';
            }
            var padding = (str.length >= len) ? '' : new Array(
                    1 + len - str.length >>> 0).join(chr);
            return leftJustify ? str + padding : padding + str;
        };

        // justify()
        var justify = function(value, prefix, leftJustify, minWidth, zeroPad,
                customPadChar) {
            var diff = minWidth - value.length;
            if (diff > 0) {
                if (leftJustify || !zeroPad) {
                    value = pad(value, minWidth, customPadChar, leftJustify);
                } else {
                    value = value.slice(0, prefix.length)
                            + pad('', diff, '0', true) + value.slice(prefix.length);
                }
            }
            return value;
        };

        // formatBaseX()
        var formatBaseX = function(value, base, prefix, leftJustify, minWidth,
                precision, zeroPad) {
            // Note: casts negative numbers to positive ones
            var number = value >>> 0;
            prefix = prefix && number && {
                '2' : '0b',
                '8' : '0',
                '16' : '0x'
            }[base] || '';
            value = prefix + pad(number.toString(base), precision || 0, '0', false);
            return justify(value, prefix, leftJustify, minWidth, zeroPad);
        };

        // formatString()
        var formatString = function(value, leftJustify, minWidth, precision,
                zeroPad, customPadChar) {
            if (precision != null) {
                value = value.slice(0, precision);
            }
            return justify(value, '', leftJustify, minWidth, zeroPad, customPadChar);
        };

        // doFormat()
        var doFormat = function(substring, valueIndex, flags, minWidth, _,
                precision, type) {
            var number, prefix, method, textTransform, value;

            if (substring === '%%') {
                return '%';
            }

            // parse flags
            var leftJustify = false;
            var positivePrefix = '';
            var zeroPad = false;
            var prefixBaseX = false;
            var customPadChar = ' ';
            var flagsl = flags.length;
            for (var j = 0; flags && j < flagsl; j++) {
                switch (flags.charAt(j)) {
                case ' ':
                    positivePrefix = ' ';
                    break;
                case '+':
                    positivePrefix = '+';
                    break;
                case '-':
                    leftJustify = true;
                    break;
                case "'":
                    customPadChar = flags.charAt(j + 1);
                    break;
                case '0':
                    zeroPad = true;
                    customPadChar = '0';
                    break;
                case '#':
                    prefixBaseX = true;
                    break;
                default:
                    break;
                }
            }

            // parameters may be null, undefined, empty-string or real valued
            // we want to ignore null, undefined and empty-string values
            if (!minWidth) {
                minWidth = 0;
            } else if (minWidth === '*') {
                minWidth = +a[i++];
            } else if (minWidth.charAt(0) == '*') {
                minWidth = +a[minWidth.slice(1, -1)];
            } else {
                minWidth = +minWidth;
            }

            // Note: undocumented perl feature:
            if (minWidth < 0) {
                minWidth = -minWidth;
                leftJustify = true;
            }

            if (!isFinite(minWidth)) {
                throw new Error('sprintf: (minimum-)width must be finite');
            }

            if (!precision) {
                precision = 'fFeE'.indexOf(type) > -1 ? 6 : (type === 'd') ? 0
                        : undefined;
            } else if (precision === '*') {
                precision = +a[i++];
            } else if (precision.charAt(0) == '*') {
                precision = +a[precision.slice(1, -1)];
            } else {
                precision = +precision;
            }

            // grab value using valueIndex if required?
            value = valueIndex ? a[valueIndex.slice(0, -1)] : a[i++];

            switch (type) {
            case 's':
                return formatString(String(value), leftJustify, minWidth,
                        precision, zeroPad, customPadChar);
            case 'c':
                return formatString(String.fromCharCode(+value), leftJustify,
                        minWidth, precision, zeroPad);
            case 'b':
                return formatBaseX(value, 2, prefixBaseX, leftJustify, minWidth,
                        precision, zeroPad);
            case 'o':
                return formatBaseX(value, 8, prefixBaseX, leftJustify, minWidth,
                        precision, zeroPad);
            case 'x':
                return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth,
                        precision, zeroPad);
            case 'X':
                return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth,
                        precision, zeroPad).toUpperCase();
            case 'u':
                return formatBaseX(value, 10, prefixBaseX, leftJustify, minWidth,
                        precision, zeroPad);
            case 'i':
            case 'd':
                number = +value || 0;
                number = Math.round(number - number % 1); // Plain Math.round
                // doesn't just truncate
                prefix = number < 0 ? '-' : positivePrefix;
                value = prefix
                        + pad(String(Math.abs(number)), precision, '0', false);
                return justify(value, prefix, leftJustify, minWidth, zeroPad);
            case 'e':
            case 'E':
            case 'f': // Should handle locales (as per setlocale)
            case 'F':
            case 'g':
            case 'G':
                number = +value;
                prefix = number < 0 ? '-' : positivePrefix;
                method = [ 'toExponential', 'toFixed', 'toPrecision' ]['efg'
                        .indexOf(type.toLowerCase())];
                textTransform = [ 'toString', 'toUpperCase' ]['eEfFgG'
                        .indexOf(type) % 2];
                value = prefix + Math.abs(number)[method](precision);
                return justify(value, prefix, leftJustify, minWidth, zeroPad)[textTransform]
                        ();
            default:
                return substring;
            }
        };

        return format.replace(regex, doFormat);
    },
    keyword2img(text) {
        text = text.replace("<", "&lt;");
        text = text.replace(">", "&gt;");
        for (var i = 0; i < window.emotions.keyword.length; ++i) {
            text = text.replace("/" + window.emotions.keyword[i], "<img src='/h5/img/emoticons/" + i + ".png'>");  
        }
        return text;
    },
    dateFormat(date) {
        var curDate = Utils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
        if (curDate.substr(0, 10) == date.substr(0, 10)) {
            return date.substr(11, 5);
        } else {
            return date.substr(5, 11);
        }
    },
}